import React, { useState, useEffect } from 'react';

// material-ui
import { CssBaseline, Button, Divider, Grid, Stack, FormControl, InputAdornment, OutlinedInput } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

//components
import AlertInfo from '../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../components/elements/AlertInfoDialog';
import TopBar from '../../components/nav/TopBar';
import SaveMailRecordForm from './components/SaveMailRecordForm'
import MailRecordsTable from './components/MailRecordsTable';
import MailRecord from './dataObjects/MailRecord';
import { Search } from '@mui/icons-material';

const MailTrackerApp = (): JSX.Element => {

    //set up browser title
    const pageTitle = 'Extranet - Mail Tracker';
    document.title = pageTitle;

    const applicationName = 'Municipal Mail Tracker';

    //set up state for the app
    const [isFormActive, setFormActive] = useState(false);
    const [mailRecords, setMailRecords] = useState<MailRecord[]>();
    const [allMailRecords, setAllMailRecords] = useState<MailRecord[]>();
    const [currentMailRecord, setCurrentMailRecord] = useState<MailRecord | null>(null);

    //payload
    useEffect(() => {
        getMailRecords();
    }, []);


    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    const openForm = () => {
        setFormActive(true);
    }

    const closeForm = (reload: boolean = false) => {
        setFormActive(false);
        setCurrentMailRecord(null);
        if (reload) {
            getMailRecords();
        }
    }

    const updateSearchInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        let searchPhrase = event.target.value;
     
        setTimeout(() => {
            if (!searchPhrase) {
                setMailRecords(allMailRecords);
            }
            else {
                let filteredRecords = mailRecords?.filter(mr => mr.description.toLowerCase().includes(searchPhrase.toLowerCase()) || mr.recipientsDescription.toLowerCase().includes(searchPhrase.toLowerCase()));
                setMailRecords(filteredRecords);
            }
        }, 800)
    }

    const getMailRecords = async () => {
        await fetch(`/StaffTools/GetMailRecords`)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: GetMailRecords',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    setMailRecords(result.result);
                    setAllMailRecords(result.result);
                }
            }
        )
    }

    const editMailRecord = (mail: MailRecord) => {
        setCurrentMailRecord(mail);
        setFormActive(true);
    }

    const deleteMailRecord = (id: number) => {
        let url = `/StaffTools/DeleteMailRecord?id=${id}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: DeleteMailRecord',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    let info = {
                        type: 'success',
                        title: 'The Mail Record Deleted',
                        errorMessage: 'The mail record was deleted successfully!',
                        secondaryErrorMessage: ''
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                    getMailRecords();
                }
            })
    }

    return (
        <div>
            <Grid container sx={{ display: 'flex' }}>
                <CssBaseline />
                <TopBar applicationName={applicationName}></TopBar>
            </Grid>
            <Grid item xs={12} marginBottom={1}>
                <Divider />
            </Grid>
            <Grid container sx={{ display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '15px' }} >
                <Grid item xs={10}>
                    <Stack direction="row" spacing={2} >
                        <FormControl sx={{ minWidth: 200 }} variant="outlined" size="small">
                            <OutlinedInput
                                aria-label='search by mail name'
                                title='search by mail name'
                                placeholder={"Search mail..."}
                                onChange={updateSearchInput}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <Button variant="outlined" startIcon={<AddIcon />} onClick={openForm} >
                            Add A New Mail Record
                        </Button>
                    </Stack>
                </Grid>
                {
                    isFormActive &&
                    <Grid item xs={8} marginTop={2} >
                        <SaveMailRecordForm closeMailRecordForm={closeForm} mailRecord={currentMailRecord}></SaveMailRecordForm>
                    </Grid>
                }
            </Grid>
            {
                mailRecords && mailRecords.length > 0 &&
                <Grid container marginTop={5} display={'flex'} justifyContent={'center'} >
                        <Grid item xs={10}>
                            <MailRecordsTable mailRecords={mailRecords} editMailRecord={editMailRecord} deleteMailRecord={deleteMailRecord} ></MailRecordsTable>
                    </Grid>
                </Grid>
            }
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </div>
    );
};

export default MailTrackerApp;